import './App.css';
import StripeWidget from './components/StripeWidget/StripeWidget.jsx';

function App() {
  return <StripeWidget />;
}

export default App;
